module.exports = __webpack_public_path__ + "static/media/shareridge.697c3628.jpg";